import React from 'react';
import { useGoBack, useLinkTo } from '../../../../hooks';
import {
  PROFILE_ROUTE,
  PROFILE_EDIT_ROUTE,
  PROVIDER_SETTINGS_MORE,
} from '../../../../route-names';
import MobileHeader, { RightButton } from '../../../provider/navigation/MobileHeader/MobileHeader';

type ProfileEditMobileHeaderProps = {
  providerId: number;
  isEditMode: boolean;
  /** Override default header */
  header?: string;
  /** Override back navigation behavior */
  onBack?: () => void;
};

export const ProProfileMobileHeader = ({
  providerId,
  isEditMode,
  header,
  onBack,
}: ProfileEditMobileHeaderProps) => {
  const linkTo = useLinkTo();
  const goBack = useGoBack();
  const handleGoBack = () => {
    if (onBack) {
      onBack();
    } else {
      goBack(PROVIDER_SETTINGS_MORE, { providerId });
    }
  };
  return (
    <MobileHeader
      header={header || 'Profile'}
      rightContent={(
        <RightButton
          onClick={() => linkTo(isEditMode ? PROFILE_ROUTE : PROFILE_EDIT_ROUTE, {
            providerId,
          })}
          testID={isEditMode ? 'previewButton' : 'editButton'}
        >
          {isEditMode ? 'Preview' : 'Edit'}
        </RightButton>
      )}
      onBack={handleGoBack}
    />
  );
};
